import { RootState } from "../store/store";

export const trsStatementsResource = (state: RootState) =>
  state.trsStatements.trsStatements.trsStatementsResource;
